import { getProviderResponses } from "root/DataFunctions/SectionFns";
import { decodeStringForPost, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { RagStatusValues } from "root/ReactHookForm/ui/ReactRAGStatus";

const pdf = require ( '../pdf/pdf.js' );

const filterResponses = ( allResponses, itemStatus ) =>
{
    return allResponses.filter ( ( item ) =>
    {
        if ( +( item.status ) === itemStatus )
        {
            return item;
        }
    } );
}

const items = (allResponses) =>
{
    const groups = allResponses.reduce ( ( finalResult, currentRecord ) =>
    {
        const found = finalResult.find ( a => a.table_section_name === currentRecord.table_section_name );

        if ( found )
        {
            found.answers.push ( currentRecord );
        }
        else
        {
            const value = {
                table_section_name: currentRecord.table_section_name,
                section_subtitle: currentRecord.section_subtitle,
                answers: [ currentRecord ]
            };

            finalResult.push ( value );
        }
        return finalResult;
    }, [] );

    return groups ;
}

export const runSchool360Report = ( enc_provider_id, academic_year, ragStatusGraphData, fullReport ) =>
{
    const survey_type = ragStatusGraphData.survey_type ;

    getProviderResponses ( enc_provider_id, academic_year, survey_type, ( response ) =>
    {
        const fullresponse = getDataFromResponse ( response );
        const allResponses = fullresponse[0].responses ;

        if ( fullReport )
        {
            const structuredResponses = items ( allResponses ) ;

            runReport ( {
                formInstance: fullresponse,
                structuredResponses: structuredResponses,
                allResponses: allResponses,
                ragStatusGraphData: ragStatusGraphData
            }, true );
        }
        else
        {
            const redResponses = filterResponses( allResponses, RagStatusValues.RED ) ;
            const amberResponses = filterResponses( allResponses, RagStatusValues.AMBER ) ;
            const greenResponses = filterResponses( allResponses, RagStatusValues.GREEN ) ;

            runReport ( {
                formInstance: fullresponse,
                redResponses: redResponses,
                amberResponses: amberResponses,
                greenResponses: greenResponses,
                allResponses: allResponses,
                ragStatusGraphData: ragStatusGraphData
            }, false );
        }
    })
}

const loadImage = ( pdfParams ) =>
{
    return new Promise ( ( resolve, reject ) =>
    {
        let img = new Image ();

        img.addEventListener ( 'load', e =>
        {

            var canvas = document.createElement ( 'canvas' );
            canvas.width = pdfParams.imageWidth; // or 'width' if you want a special/scaled size
            canvas.height = pdfParams.imageHeight; // or 'height' if you want a special/scaled size
            canvas.getContext ( '2d' ).drawImage ( img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, pdfParams.imageWidth, pdfParams.imageHeight );
            let dataURL = canvas.toDataURL ();
            let res = canvas.toDataURL ( 'image/png' );
            let t = res.replace ( /^data:image\/(png|jpg);base64,/, '' );

            resolve ( res );
        } );

        img.addEventListener ( 'error', () =>
        {
            reject ( new Error ( `Failed to load image's URL: ${ url }` ) );
        } );

        img.src = pdfParams.logoPath;
    } );
}

const stripFloat = ( number ) =>
{
    if ( number === 100 || number === -100 )
    {
        return +number;
    }
    else
    {
        return +( parseFloat ( number ).toPrecision ( 2 ) );
    }
}

const getVariableData = ( survey_type, value ) =>
{
    const rval = {
        S360:
            {
                standard_description: 'six key areas',
                table_header: 'Key Area',
                key_word: 'key areas',

            },
        S175:
            {
                standard_description: 'nine standards',
                table_header: 'Standard',
                key_word: 'standards'
            }
    }

    return rval[survey_type][value] ;
}

const outputSummarySection = ( data, survey_type ) =>
{
    const tableData = data.map ( ( item ) =>
    {
        const totals = analyseScores ( item );

        return totals ;
    });

    const greenPcentTotals = tableData.reduce((cur, rec) =>
    {
        return cur + rec.percentages.green ;
    }, 0) ;

    const avg = (greenPcentTotals / 9).toPrecision ( 2 ) ;

    const lowest = tableData.reduce((cur, rec) =>
    {
        if ( rec.percentages.green < cur.value )
        {
            return { value: rec.percentages.green, standard: rec.name}
        }
        else
        {
            return cur ;
        }
    }, { value: 100, standard: 0}) ;

    const standard_description = getVariableData ( survey_type, 'standard_description') ;
    const key_word = getVariableData ( survey_type, 'key_word') ;

    pdf.outputParagraph ( 'The self-assessment audit includes ' + standard_description + ' and the average percentage of ‘Green’ compliance across all ' + key_word + ' is ' + avg + '%.' );
    pdf.outputParagraph ( 'The lowest compliance rating is ' + lowest.standard + ' with a compliance of ' + lowest.value + '%.', '#DB1415' );
}

const analyseScores = ( standard ) =>
{
    let scores = standard.scores ;

    let totals = {
        counts: {
            total: 0,
            red: 0,
            amber: 0,
            green: 0,
            unset: 0
        },
        percentages: {
            total: 100,
            red: 0,
            amber: 0,
            green: 0,
            unset: 0
        },
        name: standard.table_section_name
    }

    const num = scores.length;
    for ( let i = 0; i < num; i++ )
    {
        const cur = scores[ i ];
        switch ( +( cur.status ) )
        {
            case RagStatusValues.RED:
                totals.counts.red = +( cur.count );
                break;
            case RagStatusValues.GREEN:
                totals.counts.green = +( cur.count );
                break;
            case RagStatusValues.AMBER:
                totals.counts.amber = +( cur.count );
                break;
            case RagStatusValues.UNSET:
                totals.counts.unset = +( cur.count );
                break;
        }

        totals.counts.total += +( cur.count );
    }

    totals.percentages.amber = Math.round ( stripFloat ( +( totals.counts.amber / totals.counts.total ) * 100 ) );
    totals.percentages.red = Math.round ( stripFloat ( +( totals.counts.red / totals.counts.total ) * 100 ) );

    if ( totals.counts.amber === 0 && totals.counts.red === 0 )
    {
        totals.percentages.green = 100;
    }
    else
    {
        const tot = totals.percentages.amber + totals.percentages.red;
        if ( tot >= 100 )
        {
            totals.percentages.green = 0;
        }
        else
        {
            totals.percentages.green = Math.round ( stripFloat ( +( 100 - ( totals.percentages.amber + totals.percentages.red ) ) ) );
        }
    }

    return totals ;
}

const outputStandards = ( data, survey_type ) =>
{
    const table_header = getVariableData ( survey_type, 'table_header') ;

    const headers = [ { text: table_header, statusG: 'Green', statusA: 'Amber', statusR: 'Red' } ];

    const tableData = data.map ( ( item ) =>
    {
        const totals = analyseScores ( item ) ;

        return [ item.table_section_name, totals.percentages.green + '%', totals.percentages.amber + '%', totals.percentages.red + '%' ];
    } )

    const columnStyles = {
        text: { cellWidth: 'auto' },
        status: { cellWidth: 100 },
        other: { cellWidth: 100 },
        more: { cellWidth: 100 }
    };

    pdf.outputTable ( headers, tableData, { columnStyles: columnStyles } );
}

const outputActions = ( entries, headers, colName, colWidth ) =>
{
    const rows = entries.map ( ( item ) =>
    {
        let txt = item.question_text.replace ( /(\r\n|\n|\r)/gm, "" );

        if ( item.summary_text !== null )
        {
            txt = item.summary_text;
        }

        const actionText = decodeStringForPost ( item[colName] );

        return [ txt, actionText ];
    } )

    const columnStyles = { text: { cellWidth: colWidth }, [colName]: { cellWidth: 'auto' } };

    pdf.outputTable ( headers, rows, { columnStyles: columnStyles } );
}

// You can convert images to data URLs here : https://ezgif.com/image-to-
const greenDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFJSURBVHgBrZQxUsJQEIa/XXTGGZt4g3gCKSlEuAG0dngDS4VCKdRSPIEeQTvtBD0AdnSG0o6G1nUfooggDiRfkeQls3/27dv9hXkcErFJTUxKvsojxOMvXYzEsDvOuZkXKjNvjqlKTq49MGIxiZk1fwvnfi60oZf+i5Y/bvA/kYhUtajYk7VnBLWuJyZ2xLIIZd3TyEUfJoJ1auPMVqXALi880xvVUBry6reYdAxsaNu5kJ3XokZ6NljjTUWlQlaEenp7xGSE73RHCY2bHbGSMWHLCdnRVZfskhE+in31S5vsuFXWfbiFAelJglEop97h2AEpGTkPX7PcoUeJLUEKrICbSpOzTy+Y2FeHexcVFy2zBJ7ZlYt9u9SUH7roI0X63vGh2RcbrNfd3m2fi2mXkj8DgqUplTCannV+nE0yajOjzdAPszV7mB8psmPjqTB5pAAAAABJRU5ErkJggg==";
const amberDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEnSURBVHgBrZTNTcNAEIW/WSQEt5RgKiAdQAeBDpITPydSQUIFkBNwSjoglJAO3AHmyC03xIEsb22CTGwisPeTRtb+PY93PM+owU/p8EYfx5GGXUWSLxgpnkzxZBfM6s5aReyBE1ZMtdJhO0H4elPYbYjdaNPjH8TIszamOjOqzTBf8Ixpxq2dM/wW9He6L72NNhindsa8ELznmfXFNxdcssvBzld2fdqzp2K+OpWlRyxWHIcqJ8TCOHSqbJd4JI7IBMGMeKQu789YeF4cHyyIx9zxrub2+inbkwWjcDaUmGdAW+Q84ZFX2S6Z6zGhKSUb++GHasOxZkb8j4mc5mo9qBps0dtBNGF7Vkt93yA4THnaft1fCPcUSambMkWqnl2wz8wG1WJ+AhScUrpLQVrtAAAAAElFTkSuQmCC"  ;
const redDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFSSURBVHgBrZRNUsJAEIVfd1i4cJEqftakSnQpnkBvoN4g3EBPAJxAOQHcwHgET2C2ilWJSyWpyoKdOO1MwBRiBCH5Fqma6aTzeqb7EXJ4tG17nysumE+F0CaR5iLkAxSKyP1hPBnlfUurG0/VxoUFNRQiG2sgQaiA/mpiXl6Ma/UbJrnblMyglTeJMBzXGt1chfOA9LAbt61ocp0lfK7WXfM3FEAJXR7F716a8KVaD0wJKEYynX04llGndboozp7F/MYMOUdJEPiMqXipGRbJMelWEZQIo2RY326IktCl+sxKfJSEgF5ZBA8oCW0iHgXaWT6tSvCf+V2HFhZqo3DYSZJELzsoTt880ls+iGOPRA2wM5LZWNY2OumVCWBLdJcMWlHU+17/Mth0toHuxgkSSRS4YxxmeZv+et8kNnM+dyFqL9SEps1MZ0zVbHSSnv9PvgDT5oJVyjFeWwAAAABJRU5ErkJggg==";

const didDrawCell = (data) =>
{
    if (data.column.index === 0 && data.cell.section === 'body')
    {
        const td = data.cell.raw;
        let img = null;
        //const dim = data.cell.height - data.cell.padding('vertical');

        switch ( +(data.cell.raw) )
        {
            case RagStatusValues.GREEN:
                img = greenDot;
                break ;
            case RagStatusValues.AMBER:
                img = amberDot ;
                break ;
            case RagStatusValues.RED:
                img = redDot ;
                break ;
            default:
                img = null ;
                break ;
        }

        const dim = 12;

        const textPos = data.cell;

        if ( img !== null )
        {
            //pdf.circle(textPos.x, textPos.y + 10, 20, 'F');
            pdf.addImage(img, textPos.x + 4,  textPos.y + 4, dim, dim);
        }
    }
}

const outputAllActions = ( entries ) =>

{
    const headers = [ { rag: '', text: 'Statement', evidence: 'Supporting Evidence' } ] ;

    entries.forEach ( (item, index, arr ) =>
    {
        const answers = item.answers;


        const rows = answers.map ( ( item ) =>
        {
            let txt = item.question_text.replace ( /(\r\n|\n|\r)/gm, "" );

            if ( item.summary_text !== null )
            {
                txt = item.summary_text;
            }

            const actionText = decodeStringForPost ( item['evidence'] );
            const ragColour = item.status

            return [ragColour, txt, actionText,  ];
        } )

        const columnStyles = {rag: {cellWidth: 30 } , text: { cellWidth: 200 }, evidence: { cellWidth: 'auto'} };

        const title = item.table_section_name ;
        const subTitle =  item.section_subtitle ;

        pdf.addPage ();
        pdf.outputHeader ( title, '#065487', 12 );
        pdf.outputParagraph( subTitle, { color: '#065487', fontSize: 10} );
        pdf.outputLine ( { fillColor: '#BCCCD8' } );
        pdf.outputTable ( headers, rows, { columnStyles: columnStyles, didDrawCell:didDrawCell } );

    })
}

const runReport = ( reportData, fullReport ) =>
{
    const shortYear = +(reportData.allResponses[0].academic_year)

    const yearString = shortYear + ' - ' + (shortYear+1);

    const pdfParams = reportData.ragStatusGraphData.pdfParams;
    const survey_type = reportData.ragStatusGraphData.survey_type;

    loadImage ( pdfParams )
        .then ( img =>
        {
            const instance = reportData.formInstance ;

            pdf.initialise ();
            pdf.insertImageCentred ( img );

            if ( fullReport )
            {
                pdf.outputTextCentred ( pdfParams.text, 24 );
            }
            else
            {
                pdf.outputTextCentred ( pdfParams.actionText, 24 );
            }

            pdf.outputTextCentred ( name, 14 );

            pdf.outputTextCentred ( yearString, 14 );
            pdf.outputParagraph ( '' )

            if ( instance[0].dmy_date_completed === null )
            {
                pdf.insertDraftWatermark ();
            }

            pdf.outputTextCentred ( reportData.ragStatusGraphData.provider_name, '14' );
            pdf.drawBorder ( 10, 5 );
            pdf.drawBorder ( 20, 5 );

            //Report Summary
            pdf.addPage ( false );
            pdf.outputHeader ( "Overview", '#065487', 12 );
            pdf.outputLine ( { fillColor: '#BCCCD8' } );

            outputSummarySection ( reportData.ragStatusGraphData.data, survey_type ) ;

            pdf.outputLine ( { fillColor: '#BCCCD8' } );
            outputStandards ( reportData.ragStatusGraphData.data, survey_type );

            const key_word = getVariableData ( survey_type, 'key_word') ;

            if ( fullReport)
            {
                pdf.outputParagraph ( 'A full list of ' + key_word + ' and responses (with evidence to support the self evaluation) is shown below.' );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }
            else
            {
                pdf.outputParagraph ( 'A list of red and amber responses (with actions to achieve compliance) is shown below.' );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }

            pdf.insertGraphImageCentred ( reportData.ragStatusGraphData );

            if ( fullReport )
            {
                outputAllActions ( reportData.structuredResponses );
            }
            else
            {
                pdf.addPage ()
                pdf.outputHeader ( 'Responses Rated Red or Amber with Actions to Achieve Compliance', '#065487', 12 );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
                pdf.outputHeader ( 'Total number of responses flagged as RED is ' + reportData.redResponses.length, '#e62309', 10 );
                outputActions ( reportData.redResponses, [ { text: 'Statement', action: 'Action' } ], 'action', 220 );

                pdf.addPage ();
                pdf.outputHeader ( 'Total number of responses flagged as AMBER is ' + reportData.amberResponses.length, '#e66819', 10 );
                outputActions ( reportData.amberResponses, [ { text: 'Statement', action: 'Action' } ], 'action', 220 );

               // pdf.addPage ();
              //  pdf.outputHeader ( 'Responses Rated Green with Evidence to Support Rating', '#065487', 12 );
              //  pdf.outputLine ( { fillColor: '#BCCCD8' } );
              //  pdf.outputHeader ( 'Total number of responses flagged as GREEN is ' + reportData.greenResponses.length, '#017B01', 10 );
             //   outputActions ( reportData.greenResponses, [ { text: 'Statement', evidence: 'Supporting Evidence' } ], 'evidence', 200  );
            }

            //closing paragraph
            pdf.addPage ()
            pdf.outputHeader ( 'Designated Safeguarding Lead Summary', '#065487', 12 );
            pdf.outputLine ( { fillColor: '#BCCCD8' } );

            const summary = instance[0].submission_summary === null ? '' : instance[0].submission_summary ;

            pdf.outputParagraph ( summary );

            if ( instance[0].dmy_date_completed === null )
            {
                pdf.outputParagraph ( 'Survey has not yet been submitted' );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }
            else
            {
                const first_name = instance[0].submitted_by_firstname ?? '' ;
                const surname = instance[0].submitted_by_surname ?? '' ;

                pdf.outputParagraph ( 'Completed by: ' + first_name + ' ' + surname );
                pdf.outputParagraph ( 'Date: ' + instance[0].dmy_date_completed );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }

            pdf.addPageNumbers ( false );

            pdf.stream ();
        } );
}